import{O as o,d as r}from"./order-progression-step2.js";const s=o,e=r;export{s as OrderProgressionStep,e as defineCustomElement}